<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
strong{
  font-size:18px;
}
</style>
<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <section class="admin-contents">
          <div class="sub-column inquiry-page-column">
            <h3 class="section-tit pt-none">제보 대상</h3>
            <button type="button" @click="adminPrint('N')" style="position:absolute;top:0;botton:0;right:105px; width:90px;border:1px solid #4174ff;color:#4174ff;padding:5px 10px;font-size:14px;font-weight:bold;">본문인쇄</button>
            <button type="button" @click="adminPrint('Y')" style="position:absolute;top:0;botton:0;right:0; width:90px;border:1px solid #4174ff;color:#4174ff;padding:5px 10px;font-size:14px;font-weight:bold;">Print</button>
            <table class="default-table admin-report-table">
              <caption>제보대상</caption>
              <colgroup>
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제보대상 회사</th>
                  <td>
                    {{adminPostVal.companyType}}
                  </td>
                  <th>제보유형</th>
                  <td>
                    {{adminPostVal.reportType}}
                  </td>
                </tr>
                <tr>
                  <th scope="row">익명 실명 여부</th>
                  <td colspan="3">
                    {{adminPostVal.postType}}
                  </td>
                </tr>
                <tr v-if="adminPostVal.postTypeCode === 'PUBLIC'">
                  <th scope="row">실명</th>
                  <td colspan="3">
                    {{adminPostUserVal.name}}
                  </td>
                </tr>
                <tr v-if="adminPostVal.postTypeCode === 'PUBLIC'">
                  <th scope="row">연락처</th>
                  <td colspan="3">
                    {{adminPostUserVal.phoneNumber}}
                  </td>
                </tr>
                <tr v-if="adminPostVal.postTypeCode === 'PUBLIC'">
                  <th scope="row">이메일</th>
                  <td colspan="3">
                    {{adminPostUserVal.email}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="sub-column inquiry-page-column">
            <h3 class="section-tit">제보 내용</h3>
            <table class="default-table admin-report-table">
              <caption>제보내용</caption>
              <colgroup>
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목</th>
                  <td>
                    <strong>{{adminPostVal.title}}</strong>
                  </td>
                  <th>제보일</th>
                  <td>
                    {{adminPostUserVal.createdDate}}
                  </td>
                </tr>
                <tr>
                  <th scope="row">제보내용</th>
                  <td colspan="3">
                    <span v-html="adminPostVal.content"></span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">첨부파일</th>
                  <td colspan="3">
                    <span class="txt-underline"><button type="button" @click="downFile(fileId, fileName)" style="color:blue;text-decoration:underline">{{fileName}}</button></span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">제보자 확인 정보</th>
                  <td>
                    최근접속: {{adminPostUserVal.lastLoginDate}}
                  </td>
                  <th>확인 횟수</th>
                  <td>
                    {{adminPostUserVal.loginSuccessCount}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="sub-column inquiry-page-column">
            <h3 class="section-tit">코멘트</h3>
            <!-- 댓글 영역 -->
            <comments-list isPrint='false'></comments-list>
            <comments-input></comments-input>
            <!-- 댓글 영역 -->
            <div class="comments-state">
              <label class="state-txt" for="state-select">상태</label>
              <select name="state-select" id="state-select" class="default-select" v-model="adminPostVal.statusCode">
                <option v-for="(type) in this.adminPostStatusList" v-bind:key="type.title" v-bind:value="type.code">
                  {{ type.title }}
                </option>
              </select>
              <button type="button" class="state-btn" @click="stateSave(adminPostVal.statusCode)">저장</button>
            </div>
          </div>
        </section>
        <section v-show="printAdmin" id="print-admin" style="width:1200px;margin: 20px auto;">
          <div style="padding:0; marign:0;">
            <h3 style="font-size: 28px;padding:20px 0; margin:0;">제보 대상</h3>
            <table style="width: 100%;border-top: 1px solid #000;text-align: left;">
              <colgroup>
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보대상 회사</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostVal.companyType}}
                  </td>
                  <th style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보유형</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostVal.reportType}}
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">익명 실명 여부</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostVal.postType}}
                  </td>
                </tr>
                <tr v-if="adminPostUserVal.email !== null">
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">실명</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.name}}
                  </td>
                </tr>
                <tr v-if="adminPostUserVal.email !== null">
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">연락처</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.phoneNumber}}
                  </td>
                </tr>
                <tr v-if="adminPostUserVal.email !== null">
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">이메일</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.email}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="padding:0; marign:0;">
            <h3 style="font-size: 28px;padding:20px 0; margin:0;">제보 내용</h3>
            <table style="width: 100%;border-top: 1px solid #000;text-align: left;">
              <colgroup>
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제목</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    <strong>{{adminPostVal.title}}</strong>
                  </td>
                  <th style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보일</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.createdDate}}
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보내용</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    <span v-html="adminPostVal.content"></span>
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">첨부파일</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    <span class="txt-underline"><button type="button" @click="downFile(fileId, fileName)">{{fileName}}</button></span>
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보자 확인 정보</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    최근접속: {{adminPostUserVal.lastLoginDate}}
                  </td>
                  <th style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">확인 횟수</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.loginSuccessCount}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="sub-column inquiry-page-column">
            <h3 class="section-tit">코멘트</h3>
            <!-- 댓글 영역 -->
            <comments-list isPrint='true'></comments-list>
          </div>
        </section>
        <section v-show="printAdmin" id="print-admin-noComment" style="width:1200px;margin: 20px auto;">
          <div style="padding:0; marign:0;">
            <h3 style="font-size: 28px;padding:20px 0; margin:0;">제보 대상</h3>
            <table style="width: 100%;border-top: 1px solid #000;text-align: left;">
              <colgroup>
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보대상 회사</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostVal.companyType}}
                  </td>
                  <th style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보유형</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostVal.reportType}}
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">익명 실명 여부</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostVal.postType}}
                  </td>
                </tr>
                <tr v-if="adminPostUserVal.email !== null">
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">실명</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.name}}
                  </td>
                </tr>
                <tr v-if="adminPostUserVal.email !== null">
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">연락처</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.phoneNumber}}
                  </td>
                </tr>
                <tr v-if="adminPostUserVal.email !== null">
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">이메일</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.email}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="padding:0; marign:0;">
            <h3 style="font-size: 28px;padding:20px 0; margin:0;">제보 내용</h3>
            <table style="width: 100%;border-top: 1px solid #000;text-align: left;">
              <colgroup>
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제목</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    <strong>{{adminPostVal.title}}</strong>
                  </td>
                  <th style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보일</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.createdDate}}
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보내용</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    <span v-html="adminPostVal.content"></span>
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">첨부파일</th>
                  <td colspan="3" style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    <span class="txt-underline"><button type="button" @click="downFile(fileId, fileName)">{{fileName}}</button></span>
                  </td>
                </tr>
                <tr>
                  <th scope="row" style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">제보자 확인 정보</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    최근접속: {{adminPostUserVal.lastLoginDate}}
                  </td>
                  <th style="vertical-align: middle;padding: 20px 0 20px 15px;color: #000;font-weight: bold;border-bottom: 1px solid #ccc;font-size: 15px;background: #f3f3f3;">확인 횟수</th>
                  <td style="vertical-align: middle;padding: 20px 0 20px 15px;border-bottom: 1px solid #ccc;color: #808080;font-size: 15px;">
                    {{adminPostUserVal.loginSuccessCount}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import CommentsList from '@/components/CommentsList'
import CommentsInput from '@/components/CommentsInput'
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
import VueHtmlToPaper from 'vue-html-to-paper'
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
}
Vue.use(VueHtmlToPaper, options)
export default {
  name: 'AdminInquiryPage',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside,
    'comments-list': CommentsList,
    'comments-input': CommentsInput
  },
  mounted () {
    this.setInit()
    this.setStatusList()
  },
  data () {
    return {
      printAdmin: false
    }
  },
  methods: {
    ...mapActions({
      setStatusList: 'apiPostStatusList',
      setInit: 'apiAdminInquiry'
    }),
    stateSave (code) {
      const params = {
        'page': this.adminPostVal.id,
        'state': code
      }
      if (confirm('상태를 변경하시겠습니까?')) {
        this.$store.dispatch('apiItemState', params)
      }
    },
    downFile (id, filename) {
      this.$store.dispatch('apiAdminAttachfile', {'id': id, 'filename': filename})
    },
    adminPrint (commentYn) {
      if (commentYn === 'Y') {
        this.$htmlToPaper('print-admin')
      } else if (commentYn === 'N') { // 본문인쇄
        this.$htmlToPaper('print-admin-noComment')
      } else {
        alert('에러가 발생했습니다. 다시 시도해주세요.')
      }
    }
  },
  computed: {
    ...mapGetters({
      adminPostVal: 'getAdminPostVal',
      adminPostUserVal: 'getAdminPostUserVal',
      fileId: 'getFileIdAdmin',
      fileName: 'getFileNameAdmin',
      adminPostStatusList: 'getPostStatusList'
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminInquiryPage.vue